import { Variants } from 'framer-motion';

export const EMPTY_FORMS_CONTAINER_ANIM: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.1,
      when: 'afterChildren',
      staggerChildren: 0.2,
    },
  },
};

export const EMPTY_FORMS_ITEM_ANIM: Variants = {
  hidden: { y: -20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export const ITEM_ANIM: Variants = {
  hidden: { y: -20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};
